import PdfPageWithText from './types/PdfPageWithText.js'
import { get_pdf_page_numbers_with_text as get_pdf_page_numbers_with_text_import, render_pdf as render_pdf_import } from './pdf_reader_wrapper.js'
import { parse as parse_import } from './pdf_parser.ts'
import { break_pdf_into_pages, deduplicate_pages, merge_invoice_pdfs as merge_invoice_pdfs_import, stamp as stamp_import } from './pdf_writer.ts'
import Invoice from '../common/models/Invoice.js'
import InvoiceInformation from '../common/models/InvoiceInformation.ts'
import Uuid from '../common/models/Uuid.ts'
import Error from '../error_handler/types/Error.ts'
import { ErrorClass } from '../error_handler/types/enums.ts'
import { md5 } from 'js-md5'

export async function get_pdf_page_numbers_with_text(pdf_bytes: Uint8Array<ArrayBufferLike>): Promise<PdfPageWithText[]> {
    try {
        return await get_pdf_page_numbers_with_text_import(pdf_bytes)
    } catch (original_error) {
        // This function is only called from parse and handled better there
        throw original_error
    }
}

export async function render_pdf(pdf_bytes: Uint8Array<ArrayBufferLike>, canvas_container: HTMLElement): Promise<void> {
    try {
        await render_pdf_import(pdf_bytes, canvas_container)
    } catch (original_error) {
        const error: Partial<Error> = {
            id: new Uuid(),
            error_message: "UNKNOWN: render_pdf failed to run successfully",
            error_class: ErrorClass.developer,
            thrown_error: original_error,
            extra_data: {
                pdf_bytes,
                canvas_container
            }
        }
        
        throw error
    }
}


export async function parse(arg_pdf_bytes: Uint8Array): Promise<Invoice[]> {
    try {
        const loc_pdf_bytes = await deduplicate_pages(arg_pdf_bytes)
        
        return await parse_import(loc_pdf_bytes)
    } catch (original_error) {
        // Finer tuned catches are in the parse function
        throw original_error
    }
}

export async function merge_invoice_pdfs(invoices: Invoice[], use_stamped_pdf: boolean): Promise<Uint8Array<ArrayBufferLike>> {
    let merged_pdf: Uint8Array<ArrayBufferLike>
    try {
        merged_pdf = await merge_invoice_pdfs_import(invoices, use_stamped_pdf)
    } catch (original_error) {
        const error: Partial<Error> = {
            id: new Uuid(),
            error_message: "UNKNOWN: merge_invoice_pdfs_import failed to run successfully",
            error_class: ErrorClass.developer,
            thrown_error: original_error,
            extra_data: {
                invoices,
                use_stamped_pdf
            }
        }
        
        throw error
    }

    return merged_pdf
}

export async function stamp(
    arg_draw_x: number, 
    arg_draw_y: number, 
    arg_invoice_information: InvoiceInformation, 
    arg_pdf_bytes: Uint8Array<ArrayBufferLike>
): Promise<Uint8Array<ArrayBufferLike>> {

    let stamped_pdf: Uint8Array<ArrayBufferLike>
    try {
        stamped_pdf = await stamp_import(arg_draw_x, arg_draw_y, arg_invoice_information, arg_pdf_bytes)
    } catch (original_error) {
        const error: Partial<Error> = {
            id: new Uuid(),
            error_message: "UNKNOWN: stamp failed to run successfully",
            error_class: ErrorClass.developer,
            thrown_error: original_error,
            extra_data: {
                arg_draw_x,
                arg_draw_y,
                arg_invoice_information,
                arg_pdf_bytes
            }
        }
        
        throw error
    }
    
    return stamped_pdf
}